import type { Data } from '@repo/strapi'
import { useTranslations } from 'next-intl'
import { Paragraph } from '@/components/typography/Paragraph'
import { cn } from '@/lib/styles'

export const PricingCardBody = ({
	pricingItem,
	yearly = false,
	className,
}: {
	pricingItem?: Data.Component<'shared.pricing-item'> | null
	yearly?: boolean
	className?: string
}) => {
	const t = useTranslations('pricing')
	const price = yearly
		? (pricingItem?.priceBilledYearly ?? pricingItem?.priceBilledMonthly)
		: pricingItem?.priceBilledMonthly

	return (
		<div className={cn('flex flex-col gap-2 px-4', className)}>
			{price != null && (
				<div className="text-9xl font-bold">
					{t('dollar')}
					{price}
					<span className="text-5xl">{t('mo')}</span>
				</div>
			)}
			<Paragraph fontSize="bodyRegularMedium" className="text-neutral-500">
				{pricingItem?.belowPriceText}
			</Paragraph>
		</div>
	)
}

export default PricingCardBody
